var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSnackbar)?_c('div',{staticClass:"snackbar",class:_vm.currentState.bgColor},[_c('div',{staticClass:"inner"},[_c('a',{staticClass:"close",attrs:{"href":"#0"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('close')}}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentState.message)}})])])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8f73710","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/Snackbar.vue
// module id = 562
// module chunks = 0